<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div class="p-20 text-center" style="border-bottom: solid 1px #E3F2FF;">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <h3 class="bold header_title dark-blue">Modifier l'adresse e-mail</h3>
      </div>

      <div class="p-20">
        <p class="dark-blue no-margin mb-10">Souhaitez-vous renvoyer un invitation à <span class="light-blue">{{contactToInvite}}</span> ?</p>

        <p class="dark-blue bold no-margin mb-10">Message additionnel (optionnel)</p>
        <textarea #messageTextarea class="w-full text-md dark-blue pap-input no-resize"
         name="message" id="message" style="height: 70px;"></textarea>
      </div>

      <div class="p-20">
        <p class="grey text-xs flex gap-20 no-margin">
          <img src="assets/warning.svg" alt="warning icon" width="20px">
          Ce message sera inclus dans l'email renvoyé avec le lien d'invitation.
        </p>
      </div>

      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;" class="p-20">
        <v8te-active-button [buttonText]="'Annuler'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
          [border]="'solid 1px #D9D9D9'" [active]="true" (click)="onDismiss(true)" [height]="50" [minWidth]="190"
          [widthPercent]="100" [bold]="true"></v8te-active-button>

        <v8te-active-button [buttonText]="'Enregistrer'" [primaryColor]="'#1990FF'" [textPrimaryColor]="'#FFFFFF'"
          (click)="onSendInvite()" [height]="50" [minWidth]="190"
          [widthPercent]="100" [bold]="true"></v8te-active-button>
      </div>
    </div>
  </div>
</div>